import AverageOverallRatingChart from '@/app/KeywordTracker/components/keywords/charts/AverageOverallRatingChart';
import CardBarChartLoading from '@/app/common/components/skeleton/CardBarChartLoading';
import DistributionOfKeywordsChart from '@/app/KeywordTracker/components/keywords/charts/DistributionOfKeywordsChart';
import ProgressDeclineOfKeywordsChart from '@/app/KeywordTracker/components/keywords/charts/ProgressDeclineOfKeywordsChart';
import {
  useGetKeywordsChartsQuery
} from '@/app/KeywordTracker/api/keywordsApi';
import { useSearchParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import DataLoadError from '@/components/errors/DataLoadError';
import {
  shouldShowDataLoadError,
  isNetworkApiError
} from '@/app/common/utils/apiErrorUtils';

const KeywordsCharts = ({ domain_slug }) => {
  const [searchParams] = useSearchParams();
  const {
    data: chartsData,
    isFetching: isLoadingCharts,
    isError,
    error,
    refetch
  } = useGetKeywordsChartsQuery({
    domain_slug,
    from_date: Number(searchParams.get('from_date')),
    to_date: Number(searchParams.get('to_date'))
  });

  if (shouldShowDataLoadError(isError, error)) {
    return (
      <Row className="g-3 mb-3">
        <Col xxl={12}>
          <DataLoadError
            error={error}
            onRetry={() => refetch()}
            isRetrying={isLoadingCharts}
            isNetworkError={isNetworkApiError(error)}
          />
        </Col>
      </Row>
    );
  }

  return (
    <Row className="g-3 mb-3">
      <Col lg={4} xxl={4}>
        {chartsData && !isLoadingCharts ? (
          <AverageOverallRatingChart
            data={chartsData?.data?.average_position}
          />
        ) : (
          <CardBarChartLoading
            limit={8}
            title={'میانگین رتبه کل'}
            width={25}
            height={10}
            margin={15}
            marginBetweenLine={7}
            showFooter={false}
          />
        )}
      </Col>
      <Col lg={4} xxl={4}>
        {chartsData && !isLoadingCharts ? (
          <DistributionOfKeywordsChart
            data={chartsData?.data?.distribution_ranks}
          />
        ) : (
          <CardBarChartLoading
            limit={8}
            title={'توزیع کلمات '}
            width={25}
            height={10}
            margin={15}
            marginBetweenLine={7}
            showFooter={false}
          />
        )}
      </Col>
      <Col lg={4} xxl={4}>
        {chartsData && !isLoadingCharts ? (
          <ProgressDeclineOfKeywordsChart
            data={chartsData?.data?.up_down_ranks?.trend_up_down}
          />
        ) : (
          <CardBarChartLoading
            title={'رشد / افت کلمات'}
            limit={8}
            width={25}
            height={10}
            margin={15}
            marginBetweenLine={7}
            showFooter={false}
          />
        )}
      </Col>
    </Row>
  );
};

export default KeywordsCharts;
